import { Routes } from '@angular/router';
import { DIVIDA_ATIVA_ROUTES } from './divida-ativa.constants';
import { permissionGuard } from '@/core/permissions/permission.guard';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';

/**
 * Rotas do módulo Dívida Ativa — 100% lazy (`loadComponent`), caminhos das constants.
 * Guard de módulo na raiz (`dividaAtiva.modulo`) e nos relatórios (`relatorios.escopo`);
 * o backend gateia os dados operacionais pelas roles `divida-ativa.*`. Lote-detalhe
 * (escrita) entra nas fases seguintes do plano com `lotes.editar`.
 */
export const dividaAtivaRoutes: Routes = [
    {
        path: DIVIDA_ATIVA_ROUTES.ROOT,
        loadComponent: () => import('./divida-ativa-content').then((m) => m.DividaAtivaContent),
        canActivate: [permissionGuard],
        data: { breadcrumb: 'Dívida Ativa', permission: PERMISSOES.dividaAtiva.modulo },
        children: [
            { path: '', redirectTo: DIVIDA_ATIVA_ROUTES.DASHBOARD, pathMatch: 'full' },
            {
                path: DIVIDA_ATIVA_ROUTES.DASHBOARD,
                loadComponent: () => import('./dashboard-divida-ativa/dashboard-divida-ativa').then((m) => m.DashboardDividaAtiva),
                data: { breadcrumb: 'Dashboard' }
            },
            {
                path: DIVIDA_ATIVA_ROUTES.RELATORIOS,
                loadChildren: () => import('./relatorios/divida-ativa-relatorios.routes').then((m) => m.DIVIDA_ATIVA_RELATORIOS_ROUTES),
                canActivate: [permissionGuard],
                data: { breadcrumb: 'Relatórios', permission: PERMISSOES.dividaAtiva.relatorios.escopo }
            },
            {
                path: DIVIDA_ATIVA_ROUTES.SERVICOS.ROOT,
                loadChildren: () => import('./servicos/divida-ativa-servicos.routes').then((m) => m.DIVIDA_ATIVA_SERVICOS_ROUTES),
                canActivate: [permissionGuard],
                data: { breadcrumb: 'Serviços', permission: PERMISSOES.dividaAtiva.lotes.escopo }
            }
        ]
    }
];
